import React, { useEffect, useState } from 'react';
import { getFormListsFromExcel } from '../utils/excelUtils';
import TicketStatusBadge from './TicketStatusBadge';
import logoAndes from '../assets/logoAndesBlanco.png';

const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

const TicketCaseDetail = ({ ticket = {}, onBack = () => {}, responsables = [] }) => {
  const [tiposIncidente, setTiposIncidente] = useState([]);
  const [responsablesSolucion, setResponsablesSolucion] = useState([]);
  const [tipoIncidenteSeleccionado, setTipoIncidenteSeleccionado] = useState('');
  const [responsableSolucionSeleccionado, setResponsableSolucionSeleccionado] = useState('');
  const [excelLoaded, setExcelLoaded] = useState(false);
  const estados = ['Abierto', 'Pendiente', 'Cerrado'];
  const [nuevoEstado, setNuevoEstado] = useState('');
  const [solucion, setSolucion] = useState('');
  const [adjuntos, setAdjuntos] = useState(null);
  const [responsableSeleccionado, setResponsableSeleccionado] = useState('');
  const [cerrando, setCerrando] = useState(false);
  const [cerrarMsg, setCerrarMsg] = useState(null);
  const [cerrarError, setCerrarError] = useState(false);
  const [detalle, setDetalle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Función para editar el caso en el backend
  const editarCaso = async () => {
    setCerrarMsg(null);
    setCerrarError(false);
    setCerrando(true);
    try {
      const formData = new FormData();
      if (detalle && detalle.wolkvox_id) {
        formData.append('wolkvoxId', detalle.wolkvox_id);
      } else {
        setCerrarMsg('No se encontró el ID de Wolkvox para editar el caso.');
        setCerrarError(true);
        setCerrando(false);
        return;
      }
      formData.append('responsible', responsableSeleccionado);
      formData.append('status', nuevoEstado);
      formData.append('solution', solucion);
      formData.append('caseType', tipoIncidenteSeleccionado);
      formData.append('responsableSolucion', responsableSolucionSeleccionado);
      if (adjuntos && adjuntos.length) {
        for (let file of Array.from(adjuntos)) {
          formData.append('attachments', file);
        }
      }
      const resp = await fetch(`${API_BASE_URL}/webhook/editar_caso`, {
        method: 'POST',
        body: formData
      });
      const json = await resp.json();
      if (json.error) {
        setCerrarMsg(json.msg || 'Error al editar el caso.');
        setCerrarError(true);
      } else {
        setCerrarMsg(json.msg || 'Caso editado correctamente.');
        setCerrarError(false);
        // Cerrar la pestaña de detalles y volver al panel principal
        setTimeout(() => {
          onBack();
        }, 1200);
      }
    } catch (error) {
      setCerrarMsg('Error al editar el caso.');
      setCerrarError(true);
    }
    setCerrando(false);
  };

  useEffect(() => {
    // Leer el Excel para poblar las listas
    // Primero cargar el Excel y luego el detalle
    const fetchExcelLists = async () => {
      try {
        // Usar ruta pública para el archivo Excel
        const url = '/formulario_soporte.xlsx';
        const data = await getFormListsFromExcel(url);
        setTiposIncidente(data.tiposIncidente || []);
        setResponsablesSolucion(data.responsablesSolucion || []);
        setExcelLoaded(true);
      } catch (error) {
        setTiposIncidente([]);
        setResponsablesSolucion([]);
        setExcelLoaded(true);
      }
    };
    fetchExcelLists();
    if (!ticket.id) return;
    const fetchDetalle = async () => {
      setLoading(true);
      try {
        const resp = await fetch(`${API_BASE_URL}/webhook/detalle_caso`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ idCase: ticket.id })
        });
        const json = await resp.json();
        if (json.data && typeof json.data === 'object') {
          setDetalle(json.data);
          // Setear el estado por defecto del select
          if (json.data.status && json.data.status.name) {
            setNuevoEstado(json.data.status.name);
          }
        } else {
          setError('No se encontró el detalle del caso');
        }
      } catch (err) {
        setError('Error al consultar el detalle del caso');
      }
      setLoading(false);
    };
    fetchDetalle();
  }, [ticket.id]);

  // Cuando ambos: detalle y listas de Excel estén cargados, setear los valores predeterminados
  useEffect(() => {
    if (detalle && excelLoaded) {
      // Preselección de Tipo de Incidente usando form.TipoIncidenteV2
      if (detalle.form && detalle.form['TipoIncidenteV2'] && tiposIncidente.includes(detalle.form['TipoIncidenteV2'])) {
        setTipoIncidenteSeleccionado(detalle.form['TipoIncidenteV2']);
      } else {
        setTipoIncidenteSeleccionado('');
      }
      if (detalle.form && detalle.form['Responsable Solución'] && responsablesSolucion.includes(detalle.form['Responsable Solución'])) {
        setResponsableSolucionSeleccionado(detalle.form['Responsable Solución']);
      } else {
        setResponsableSolucionSeleccionado('');
      }
      // Preselección de Responsable por nombre (no id)
      if (detalle.responsible && detalle.responsible.name && Array.isArray(responsablesList)) {
        console.log('[RESP LOG] detalle.responsible.name:', detalle.responsible.name);
        console.log('[RESP LOG] responsablesList:', responsablesList);
        // Extraer solo el nombre antes del ' - '
        const nombreBack = detalle.responsible.name.split(' - ')[0].trim().toLowerCase();
        const encontrado = responsablesList.find(r => {
          const nombreLista = r.nombre ? r.nombre.trim().toLowerCase() : '';
          console.log('[RESP LOG] comparando:', nombreLista, 'vs', nombreBack);
          return nombreLista === nombreBack;
        });
        if (encontrado) {
          console.log('[RESP LOG] Responsable encontrado:', encontrado);
          setResponsableSeleccionado(encontrado.id);
        } else {
          console.log('[RESP LOG] No se encontró responsable que coincida.');
          setResponsableSeleccionado('');
        }
      } else {
        console.log('[RESP LOG] detalle.responsible o responsablesList no válidos:', detalle.responsible, responsablesList);
        setResponsableSeleccionado('');
      }
    }
  }, [detalle, excelLoaded, tiposIncidente, responsablesSolucion]);

  if (!ticket.id) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
          <p className="text-gray-600">No se ha seleccionado ningún ticket para mostrar.</p>
          <button
            onClick={onBack}
            className="mt-6 px-6 py-2 bg-custom-blue text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Volver
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
          <p className="text-gray-600">Cargando detalle del caso...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
          <p className="text-red-600">{error}</p>
          <button
            onClick={onBack}
            className="mt-6 px-6 py-2 bg-custom-blue text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Volver
          </button>
        </div>
      </div>
    );
  }

  // Si la prop 'responsables' está vacía, construir la lista a partir de ticket o detalle
  let responsablesList = responsables;

  // Si 'responsables' es un arreglo de strings tipo "NOMBRE - id", lo convertimos a objetos { id, nombre } y capitalizamos el nombre
  if (Array.isArray(responsables) && responsables.length > 0) {
    // Convertir y eliminar duplicados por id
    const vistos = new Set();
    responsablesList = responsables.map(r => {
      const [nombre, id] = r.split(' - ');
      const nombreCapitalizado = nombre
        .toLowerCase()
        .replace(/\b\w/g, l => l.toUpperCase());
      return { id, nombre: nombreCapitalizado };
    }).filter(r => {
      if (!r.id || vistos.has(r.id)) return false;
      vistos.add(r.id);
      return true;
    });
  }

  // Renderizar detalle completo del caso
  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Caso #{detalle.idCase}</h1>
          <button
            onClick={onBack}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Volver a Tickets
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div>
            <p className="text-sm text-gray-500">Estado</p>
            <TicketStatusBadge status={detalle.status?.name} />
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-2">Tipo de Incidente</p>
            <select
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              value={tipoIncidenteSeleccionado}
              onChange={e => setTipoIncidenteSeleccionado(e.target.value)}
            >
              <option value="">Seleccione tipo</option>
              {tiposIncidente.map((tipo, idx) => (
                <option key={idx} value={tipo}>{tipo}</option>
              ))}
            </select>
          </div>
          <div>
            <p className="text-sm text-gray-500">Prioridad</p>
            <p className="text-gray-800 font-medium">{detalle.priority?.name}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Solicitante</p>
            <p className="text-gray-800 font-medium">{detalle.form?.['Nombre del Solicitante']}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Correo Solicitante</p>
            <p className="text-gray-800 font-medium">{detalle.contactEmail}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Teléfono</p>
            <p className="text-gray-800 font-medium">{detalle.contactTel?.value}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Campaña</p>
            <p className="text-gray-800 font-medium">{detalle.form?.['Campaña']}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Sede</p>
            <p className="text-gray-800 font-medium">{detalle.form?.['Sede']}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Número de Puesto</p>
            <p className="text-gray-800 font-medium">{detalle.form?.['Número del Puesto']}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Requiere Autorización</p>
            <p className="text-gray-800 font-medium">{detalle.form?.['Requiere Autorización']}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-2">Responsable Solución</p>
            <select
              className="w-full max-w-xs px-4 py-2 border border-gray-300 rounded-lg"
              value={responsableSolucionSeleccionado}
              onChange={e => setResponsableSolucionSeleccionado(e.target.value)}
            >
              <option value="">Seleccione responsable</option>
              {responsablesSolucion.map((resp, idx) => (
                <option key={idx} value={resp}>{resp}</option>
              ))}
            </select>
          </div>
          <div>
            <p className="text-sm text-gray-500">Fecha estimada de cierre</p>
            <p className="text-gray-800 font-medium">{detalle.timeEstimated}</p>
          </div>
        </div>

        {/* Selector de estado y cierre de ticket */}
        {(detalle.status?.name === 'Abierto' || detalle.status?.name === 'Pendiente') && (
          <div className="mb-8">
            <p className="text-sm text-gray-500 ">Cambiar estado del ticket</p>
            <select
              className="w-full max-w-xs px-4 py-2 border border-gray-300 rounded-lg"
              value={nuevoEstado}
              onChange={e => setNuevoEstado(e.target.value)}
            >
              {estados.map(e => (
                <option key={e} value={e}>{e}</option>
              ))}
            </select>

            {/* Espacio visual entre estado y responsable */}
            <div className="h-4" />

            {/* Lista de responsables para reasignar el caso (solo uno) */}
            <div className="mb-8">
              <p className="text-sm text-gray-500 mb-2">Responsable</p>
              <select
                className="px-4 py-2 rounded-lg border border-gray-300 bg-white shadow-sm w-full max-w-xs"
                value={responsableSeleccionado}
                onChange={e => setResponsableSeleccionado(e.target.value)}
              >
                <option value="">Seleccione responsable</option>
                {Array.isArray(responsablesList) && responsablesList.map((r, idx) => (
                  <option key={r.id || idx} value={r.id}>{r.nombre}</option>
                ))}
              </select>
            </div>

            {/* Solo mostrar el botón de guardar si el estado es Abierto */}
            {nuevoEstado === 'Abierto' && (
              <div className="mt-4">
                <button
                  className={`px-6 py-2 bg-custom-green-500 text-white rounded-lg font-bold shadow hover:bg-custom-green-700 transition-colors ${cerrando ? 'opacity-60 cursor-not-allowed' : ''}`}
                  disabled={cerrando}
                  onClick={editarCaso}
                >
                  {cerrando ? 'Procesando...' : 'Guardar'}
                </button>
                {cerrarMsg && (
                  <div className={`mt-4 text-center font-semibold ${cerrarError ? 'text-red-600' : 'text-green-600'}`}>{cerrarMsg}</div>
                )}
              </div>
            )}

            {/* Mostrar campos de solución y adjuntos solo si el estado es Pendiente o Cerrado */}
            {(nuevoEstado === 'Pendiente' || nuevoEstado === 'Cerrado') && (
              <div className="mt-4">
                <label className="block text-gray-700 font-semibold mb-2">Solución</label>
                <textarea
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                  rows={3}
                  value={solucion}
                  onChange={e => setSolucion(e.target.value)}
                  placeholder="Describe la solución..."
                  required
                />
                <label className="block text-gray-700 font-semibold mt-4 mb-2">Adjuntar archivos</label>
                <input
                  type="file"
                  multiple
                  accept=".xlsx,.csv,.pdf,.jpg,.png,.docx,.mp4,.mp3,.wmv,.wma,.wap,.doc,.jpeg,.avi,.bmp,.bpm,.mov,.tiff"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                  onChange={e => setAdjuntos(e.target.files)}
                />
                <button
                  className={`mt-4 px-6 py-2 bg-custom-green-500 text-white rounded-lg font-bold shadow hover:bg-custom-green-700 transition-colors ${cerrando ? 'opacity-60 cursor-not-allowed' : ''}`}
                  disabled={cerrando}
                  onClick={editarCaso}
                >
                  {cerrando ? 'Procesando...' : 'Guardar'}
                </button>
                {cerrarMsg && (
                  <div className={`mt-4 text-center font-semibold ${cerrarError ? 'text-red-600' : 'text-green-600'}`}>{cerrarMsg}</div>
                )}
              </div>
            )}
          </div>
        )}

        <div className="mb-8">
          <p className="text-sm text-gray-500 mb-2">Descripción Detallada</p>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 text-gray-700 text-base leading-relaxed">
            {detalle.description_case || 'No hay descripción detallada disponible.'}
          </div>
        </div>

        {/* Historial de acciones */}
        <div className="mb-8">
          <p className="text-sm text-gray-500 mb-2">Historial de acciones</p>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 text-gray-700 text-sm">
            {detalle.history && detalle.history.length > 0 ? (
              <ul className="space-y-2">
                {detalle.history.map((h, idx) => (
                  <li key={idx} className="border-b pb-2">
                    <span className="font-semibold text-custom-green-700">{h.date}:</span> {h.message} <span className="text-gray-500">({h.user})</span>
                  </li>
                ))}
              </ul>
            ) : (
              <span>No hay historial disponible.</span>
            )}
          </div>
        </div>

        <div className="mt-8 flex justify-end space-x-3">
          {/* Botones eliminados por solicitud */}
        </div>
      </div>
    </div>
  );
};

export default TicketCaseDetail;